// extracted by mini-css-extract-plugin
module.exports = {"rate-img":"RateImg_rate-img__3hlAq","rate-img-box":"RateImg_rate-img-box__2Vz9-"};